import { Component, input, ChangeDetectionStrategy } from '@angular/core'
import { MatTooltipModule } from '@angular/material/tooltip'

@Component({
  selector: 'lib-status-pulse',
  imports: [MatTooltipModule],
  templateUrl: './status-pulse.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './status-pulse.component.scss',
})
export class StatusPulseComponent {
  readonly tooltip = input<string>()
  readonly color = input<string>('#f2aa4c')
}
